import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import bg from "../img/bg.mp4";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { layout } from "../components/Layout";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  ContentSideBySideCustom,
  ContentSideBySideCustomNoAnim,
  Hero,
  Gallery,
  News,
  FeatureCard,
  Stats,
  SpacerV,
  FeatureCardSmall,
  SpacerH,
  ContentSideBySideCustomInv,
} from "../components/Hero";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Grid } from "@mui/material";
import { Up, Down, Left, Right } from "../components/PositionFade";
import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "../components/PositionFadeInView";
import { useInView, useSpring, animated, useScroll } from "@react-spring/web";
import { config } from "react-spring";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import { TypeAnimation } from "react-type-animation";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import Carousel from "react-spring-3d-carousel";
import background from "../img/1.jpg";
import ScrollContainer from "../components/ScrollContainer";

import { API_URL } from "../actions/auth";
import axios from "axios";
import { Marquee, Platforms, Trust } from "../components/Sections";
{
  /* <video src={require("../img/2.mp4")} autoPlay loop muted></video> */
}

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const testimonials = [
  {
    quote:
      "The support we've received from the team at Riches Media Digital has been truly invaluable and we cannot thank them enough for the 4+ years. Their expertise and seamless integration into our operations have played a pivotal role in advancing our agency's goals. From handling ad operations to meticulously setting up campaigns across various Social & Programmatic platforms, their assistance has been unparalleled. Their dedication and professionalism are evident in every interaction, making them feel like an integral part of our own team",
    image: require("../img/test1.jpg"),
    imageAlt:
      "Davin. Group Digital Director - Slingshot Media Ventures Pty Ltd",
    name: "Davin Marcello",
    role: "GROUP DIGITAL DIRECTOR - SLINGSHOT MEDIA VENTURES PTY LTD",
  },
  {
    quote:
      "I've been working with Riches Media for over 3.5 years from the initial start-up phase to what they have taken the team to now in a short time frame. The team's digital know-how, communication and support is top notch and all clienteles have always been very happy with their services. They have supported the clients across many platforms including TTD, DV360, SA360, Campaign Manager, Google Ads and Facebook Ads. Over the years we've become not just good business partners but also great friends. I'd highly recommend working with the talented team at Richesmedia.",
    image: require("../img/test2.png"),
    imageAlt:
      "Sanjaya. Managing Partner and Co-Founder, AdSparc Sydney NSW, Australia",
    name: "Sanjaya",
    role: "MANAGING PARTNER & CO-FOUNDER, ADSPARC SYDNEY NSW, AUSTRALIA",
  },
  {
    quote:
      "Programmatic Media has been working with Riches Media for nearly two years now, and their support has been invaluable in running our Digital Performance activity with a number of clients from a variety of verticals and campaign objectives. Things move at a very fast pace, and the team has always been quick to respond, willing, and dedicated to ensuring campaign delivery on time. They have provided support across many specialties and platforms, including The Trade Desk, DV360, SA360, Campaign Manager, Google Ads, and Facebook Ads.",
    image: require("../img/jamie.jpeg"),
    imageAlt: "Jamie, Head of Digital-Hyland Division, Programmatic Media",
    name: "Jamie",
    role: "HEAD OF DIGITAL-HYLAND DIVISION, PROGRAMMATIC MEDIA",
  },
  {
    quote:
      "We have been working with the Riches Media team for more than a year already, and we really appreciate the attention and dedication they put into working with us. Always quick to reply and ready to help. We are very satisfied with our partnership.",
    image: require("../img/rafael.jpeg"),
    imageAlt: "Rafael. CEO, Exiber",
    name: "Rafael",
    role: "CEO, EXIBER",
  },
];

function getBlogImageUrl(blog) {
  if (!blog?.image_url) {
    return background;
  }
  if (blog.image_url.startsWith("http")) {
    return blog.image_url;
  }
  return API_URL + blog.image_url.replace(/^\//, "");
}

function HomeTestimonials({ state }) {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const testimonial = testimonials[activeTestimonial];

  const goToNextTestimonial = () => {
    setActiveTestimonial((current) => (current + 1) % testimonials.length);
  };

  const goToPreviousTestimonial = () => {
    setActiveTestimonial(
      (current) => (current - 1 + testimonials.length) % testimonials.length
    );
  };

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setActiveTestimonial((current) => (current + 1) % testimonials.length);
    }, 5000);

    return () => window.clearTimeout(timer);
  }, [activeTestimonial]);

  return (
    <div className="home-testimonials">
      <article className="home-testimonial-card anigrad">
        <FormatQuoteIcon className="home-testimonial-quote-icon" />
        <p
          className="home-testimonial-copy"
          style={{ fontSize: layout.textMedium[state.auth.view] }}
        >
          {testimonial.quote}
        </p>
        <FormatQuoteIcon className="home-testimonial-quote-icon" />
        <img
          className="home-testimonial-avatar"
          src={testimonial.image}
          alt={testimonial.imageAlt}
        />
        <div
          className="home-testimonial-name"
          style={{ fontSize: layout.textMedium[state.auth.view] }}
        >
          - {testimonial.name}
        </div>
        <div className="home-testimonial-role">{testimonial.role}</div>
      </article>
      <div
        className="home-testimonial-controls"
        aria-label="Testimonial navigation"
      >
        <button
          type="button"
          className="home-testimonial-control"
          onClick={goToNextTestimonial}
          aria-label="Next testimonial"
        >
          <ArrowRightIcon style={{ fontSize: "6vh" }} />
        </button>
        <button
          type="button"
          className="home-testimonial-control"
          onClick={goToPreviousTestimonial}
          aria-label="Previous testimonial"
        >
          <ArrowLeftIcon style={{ fontSize: "6vh" }} />
        </button>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const timelineDelays = [0, 300, 600];

  const state = useSelector((state) => state);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const [blogs, setBlogs] = useState({ Latest: [{ title: "Loading" }] });

  useEffect(() => {
    axios
      .get(API_URL + "get_all_blog_posts")
      .then((res) => {
        setBlogs(res.data);
      })
      .catch((err) => {});
    setTimeout(() => {
      line1api.start({
        config: {
          duration: 10000,
        },
        from: {
          width: "0%",
        },
        to: {
          width: "50%",
        },
      });
    }, 250);
  }, []);
  const [news, setNews] = useState([]);
  const [gallery, setGallery] = useState([]);

  const [line1, line1api] = useSpring(() => ({
    from: { width: "0%" },
  }));

  const {
    carouselFragment: carouselFragment2,
    slideToPrevItem: slideToPrevItem2,
    slideToNextItem: slideToNextItem2,
  } = useSpringCarousel({
    id: "blogCarousel",
    withLoop: true,
    items: blogs["Latest"].map((blog, index) => {
      return {
        id: "blog" + index.toString(),
        renderItem: (
          <Link
            to={"/blog/" + blog.slug + "/"}
            params={{ slug: blog.slug }}
            style={{
              width: "100%",
              cursor: "pointer",
              textDecoration: "none",
              margin: "15px",
            }}
          >
            <div
              style={{
                cursor: "pointer",
                height: "100%",
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundImage:
                  "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(0, 0, 0, 0.5), rgba(2, 77, 194, 0.0)), url('" +
                  getBlogImageUrl(blog) +
                  "')",
                borderRadius: 10,
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
              }}
            >
              <div
                style={{
                  fontSize: "3.6vh",
                  position: "absolute",
                  left: 40,
                  bottom: 40,
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {blog.title}
              </div>
            </div>
          </Link>
        ),
      };
    }),
  });

  useEffect(() => {
    const timer = window.setInterval(() => {
      slideToNextItem2();
    }, 5000);

    return () => window.clearInterval(timer);
  }, [slideToNextItem2]);

  const [zoom3, zoom3api] = useSpring(() => ({
    config: {
      duration: 500,
    },
    opacity: 1,
    display: "block",
  }));

  const [scrollVal, setScrollVal] = React.useState(1);
  const [scrollOpacity, setScrollOpacity] = React.useState(0);
  const [scrollTranslate, setScrollTranslate] = React.useState(0);
  const [scrolly, setScrolly] = React.useState(0);

  const { scrollYProgress } = useScroll({
    onChange: ({ value: { scrollYProgress } }) => {
      if (!state.auth.isMobile) {
        setScrolly(scrollYProgress);
        setScrollVal(scrollYProgress * 20 + 1);
        if (scrollYProgress > 0.15) {
          zoom3api.start({ opacity: 0, display: "none" });
        } else {
          zoom3api.start({ opacity: 1, display: "block" });
        }
      }
    },
  });

  function getContent() {
    return (
      <div className="main" style={{ backgroundColor: "#111" }}>
        <Sidebar />
        <div
          style={{
            width: "100vw",
            height: "100vh",
            zIndex: 100,
          }}
        >
          <video
            style={{ filter: "blur(1px) brightness(50%)" }}
            src={bg}
            type="video/mp4"
            autoPlay
            loop
            muted
            id="video"
            className="video"
          />
          <div
            className="content"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                transform: "translate(0%, -70vh)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 99,
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile
                    ? "28px"
                    : layout.heading[state.auth.view],
                  color: "white",
                  fontWeight: "bold",
                  width: state.auth.isMobile ? "100%" : "auto",
                  maxWidth: state.auth.isMobile ? "92vw" : "90vw",
                  minWidth: 0,
                  boxSizing: "border-box",
                  padding: state.auth.isMobile ? "0 14px" : "0",
                  lineHeight: 1.1,
                  textAlign: "center",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                Riches Media Digital
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile
                    ? "20px"
                    : layout.subheading[state.auth.view],
                  color: "white",
                  width: state.auth.isMobile ? "100%" : "auto",
                  maxWidth: state.auth.isMobile ? "92vw" : "90vw",
                  minWidth: 0,
                  boxSizing: "border-box",
                  padding: state.auth.isMobile ? "12px 14px 0" : "0",
                  lineHeight: 1.35,
                  textAlign: "center",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                <h1>
                  {state.auth.isMobile ? (
                    <>
                      #1 Digital Marketing Agency
                      <br />
                      for Business Growth
                    </>
                  ) : (
                    "#1 Digital Marketing Agency for Business Growth"
                  )}
                </h1>
              </div>
              <animated.div
                style={{
                  height: "2px",
                  backgroundColor: "white",
                  margin: "3vw 0px 3vw 0px",
                  ...line1,
                }}
              ></animated.div>
              <div
                style={{
                  fontSize: state.auth.isMobile
                    ? "20px"
                    : layout.subheading[state.auth.view],
                  color: "white",
                  width: state.auth.isMobile ? "100%" : "90vw",
                  maxWidth: !state.auth.isMobile ? "90vw" : "92vw",
                  minWidth: 0,
                  boxSizing: "border-box",
                  padding: state.auth.isMobile ? "0 14px" : "0",
                  lineHeight: state.auth.isMobile ? 1.35 : 1.45,
                  textAlign: "center",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {state.auth.isMobile ? (
                  <>
                    We develop data-driven
                    <br />
                    digital marketing strategies
                    <br />
                    that drive
                  </>
                ) : (
                  <>
                    We develop data-driven digital marketing strategies that
                    drive
                    <br />
                  </>
                )}
                <b
                  style={{
                    color: "yellow",
                    display: state.auth.isMobile ? "block" : "inline",
                    marginLeft: 0,
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {state.auth.isMobile ? (
                    <>
                      customer engagement
                      <br />
                      and 10x revenue.
                    </>
                  ) : (
                    " customer engagement and 10x revenue."
                  )}
                </b>
              </div>
            </div>
          </div>
        </div>

        <div style={{ height: "100px", backgroundColor: "#111" }} />
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            color: "white",
            zIndex: 99,
            backgroundColor: "#111",
            fontWeight: "bold",
          }}
        >
          <h2> Transform Clicks into Conversions, Drive Growth That Lasts</h2>
        </div>
        {state.auth.isMobile ? (
          <div style={{ marginBottom: "-50px", backgroundColor: "#111" }} />
        ) : (
          ""
        )}
        <div
          style={{
            width: "100vw",
            backgroundColor: "#111",
            paddingBottom: "125px",
          }}
        >
          <ContentSideBySideCustomNoAnim
            onClick={() => {
              navigate("/programmatic-advertising");
            }}
            background={"#111"}
            titleColor={"white"}
            subtitleColor={"white"}
            titleFontSize={state.auth.isMobile ? "26px" : "32px"}
            subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
            title="Paid Ads and Monetization"
            subtitle="Our <a href='https://richesmediadigital.com/pay-per-click/'>paid advertising solutions</a> maximize return on investment by targeting the right audience with highly optimized ad campaigns. We design performance-driven ad strategies that increase conversions and profitability."
            image={
              <Lottie
                style={{
                  borderRadius: "1px",
                  height: "100%",
                  width: state.auth.isMobile ? "90%" : "100%",
                  backgroundPosition: "center",
                  backgroundFit: "cover",
                  marginLeft: "25px",
                  marginTop: state.auth.isMobile ? "-60px" : "50px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/temp3.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <ContentSideBySideCustomNoAnim
            background={"#111"}
            titleColor={"white"}
            subtitleColor={"white"}
            titleFontSize={state.auth.isMobile ? "26px" : "32px"}
            subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
            title="SEO: Rank Higher, Get Discovered, Increase Conversions"
            subtitle="We implement <a href='https://richesmediadigital.com/search-engine-optimization/'>SEO-optimized strategies</a> that improve organic search rankings and drive targeted traffic. Our approach includes technical SEO, keyword research, and link-building to maximize search engine authority. We also create high-impact social media campaigns that grow brand presence on Instagram, Facebook, LinkedIn, and Twitter. Our strategies drive customer engagement, loyalty, and sales."
            image={
              <Lottie
                style={{
                  borderRadius: "1px",
                  height: "100%",
                  width: state.auth.isMobile ? "90%" : "100%",
                  backgroundPosition: "center",
                  backgroundFit: "cover",
                  marginLeft: "25px",
                  marginTop: state.auth.isMobile ? "-60px" : "50px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/temp4.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <ContentSideBySideCustomNoAnim
            background={"#111"}
            titleColor={"white"}
            subtitleColor={"white"}
            titleFontSize={state.auth.isMobile ? "26px" : "32px"}
            subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
            title="Analytics in Digital Marketing"
            subtitle="<a href='https://richesmediadigital.com/end-to-end-analytics/'>Data-driven marketing</a> decisions drive higher ROI and improved campaign performance. At Riches Media Digital, we use real-time analytics to track customer behavior and website performance. Businesses can optimize targeting and increase engagement by analyzing SEO, social media, and paid ad data. We help brands improve conversion rates and user experience through real-time campaign tracking and A/B testing. Companies can eliminate inefficiencies and boost marketing efficiency by using our data-driven insights."
            image={
              <Lottie
                style={{
                  borderRadius: "1px",
                  height: "100%",
                  width: state.auth.isMobile ? "90%" : "100%",
                  backgroundPosition: "center",
                  backgroundFit: "cover",
                  marginLeft: "25px",
                  marginTop: state.auth.isMobile ? "-60px" : "50px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/temp2.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
        </div>
        <div
          style={{
            fontSize: state.auth.isMobile ? "20px" : "50px",
            color: "white",
            zIndex: 99,
            marginTop: "50px",
            backgroundColor: "#111",
            fontWeight: "bold",
            marginTop: state.auth.isMobile ? "-80px" : "0px",
          }}
        >
          <h2>Strategic & Data-Driven Digital Marketing Agency for Scalable</h2>{" "}
          <br />
          <h2>Success Driving Results, Redefining Possibilities.</h2>
        </div>
        <div
          style={{
            paddingTop: state.auth.isMobile ? "100px" : "300px",
            width: "100%",
            backgroundColor: "#111",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: state.auth.isMobile ? "210vh" : "90vh",
            marginRight: state.auth.isMobile ? "-50px" : "-50px",
          }}
        >
          <Grid
            container
            style={{
              height: state.auth.isMobile ? "100vh" : "100vh",
              width: "80%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox1.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox1.height[state.auth.view],
                  width: layout.dashboardBox1.width[state.auth.view],
                  marginLeft: layout.dashboardBox1.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox1.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox1.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>Strategic Innovation</div>{" "}
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Implement the latest digital marketing trends{" "}
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox2.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox2.height[state.auth.view],
                  width: layout.dashboardBox2.width[state.auth.view],
                  marginLeft: layout.dashboardBox2.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox2.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox2.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>Marketing Efficiency</div>{" "}
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Streamline advertising, content, and automation workflows
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox1.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox1.height[state.auth.view],
                  width: layout.dashboardBox1.width[state.auth.view],
                  marginLeft: layout.dashboardBox1.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox1.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox1.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>AI-Powered Automation</div>{" "}
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Scale marketing efforts with smart automation
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox2.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox2.height[state.auth.view],
                  width: layout.dashboardBox2.width[state.auth.view],
                  marginLeft: layout.dashboardBox2.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox2.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox2.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>
                  Scalable Digital Strategies
                </div>{" "}
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Expand reach with targeted online campaigns
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox1.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox1.height[state.auth.view],
                  width: layout.dashboardBox1.width[state.auth.view],
                  marginLeft: layout.dashboardBox1.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox1.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox1.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>Data-Driven Optimization</div>{" "}
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Use analytics to enhance performance and ROI
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent:
                  layout.dashboardBox2.justifyContent[state.auth.view],
              }}
            >
              <div
                className={"anigrad"}
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid grey",
                  height: layout.dashboardBox2.height[state.auth.view],
                  width: layout.dashboardBox2.width[state.auth.view],
                  marginLeft: layout.dashboardBox2.marginLeft[state.auth.view],
                  marginRight:
                    layout.dashboardBox2.marginRight[state.auth.view],
                  marginTop: layout.dashboardBox2.marginTop[state.auth.view],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div style={{ fontSize: "6vh" }}>Multi-Channel Approach</div>
                <br />
                <div style={{ fontSize: "2.2vh" }}>
                  Connect SEO, paid ads, and social media
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            display:
              state.auth.isMobile || state.auth.view == "TABP"
                ? "none"
                : "block",
          }}
        >
          <Platforms invert />
        </div>

        {state.auth.isMobile ? (
          <SpacerV height={"100px"} background="#111" />
        ) : (
          ""
        )}
        {state.auth.isTablet ? (
          <SpacerV height={"600px"} background="#111" />
        ) : (
          ""
        )}
        {state.auth.view == "TABP" ? (
          <SpacerV height={"2300px"} background="#111" />
        ) : (
          ""
        )}
        <SpacerV height={"100px"} background="white" />
        <Marquee invert />
        <SpacerV height={"100px"} background="white" />

        <div
          style={{
            paddingTop: "50px",
            paddingBottom: "100px",
            display:
              state.auth.isMobile || state.auth.view == "TABP"
                ? "none"
                : "block",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "25px" : "50px",
              color: "white",
              zIndex: 99,
              fontWeight: "bold",
            }}
          >
            <h2>Why Choose Us As Your Digital Marketing Company</h2>
          </div>
          <br />
          <TabContext value={value}>
            {!state.auth.isMobile ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  background: "transparent",
                  maxWidth: "100vw",
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Innovation"
                    value="1"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                  <Tab
                    label="Efficiency"
                    value="2"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                  <Tab
                    label="Automation"
                    value="3"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                  <Tab
                    label="Scalability"
                    value="4"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                  <Tab
                    label="Data-Driven"
                    value="5"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                  <Tab
                    label="Connectivity "
                    value="6"
                    style={{
                      fontSize: "22px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                </TabList>
              </Box>
            ) : (
              <div
                style={{ marginBottom: state.auth.isTablet ? "0px" : "-100px" }}
              />
            )}
            <TabPanel value="1">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Unlock New Opportunities with Cutting-Edge Solutions"
                subtitle="Unlock New Opportunities with Cutting-Edge Solutions
Embracing innovation means adopting the latest technologies that can propel your business forward. New tools, platforms, and systems not only make your operations more effective but also open up new market opportunities. By staying ahead of the curve, you can introduce products and services that meet evolving customer needs. Innovation fosters creativity within teams, enabling your business to solve complex challenges, differentiate from competitors, and drive growth. In a world where change is constant, harnessing technological advancements allows you to maintain a competitive edge and respond swiftly to market demands."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                      marginTop: state.auth.isMobile ? "-100px" : "0px",
                    }}
                    alt={"Cutting Edge Digital Marketing"}
                    src={require("../img/tab4.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="2">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Streamline Processes for Maximum Productivity"
                subtitle="Efficiency is about making the most of your resources and time. By leveraging advanced technologies, businesses can automate routine tasks, reduce human error, and optimize workflows. This leads to faster decision-making, minimized costs, and increased output. For instance, tools like project management software, CRM systems, and AI-powered solutions enable teams to focus on high-value tasks rather than manual processes. Streamlining operations means more efficient use of both human and capital resources, which translates to enhanced productivity and greater profitability. Ultimately, efficiency allows businesses to do more with less while maintaining quality and consistency."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    src={require("../img/metaverse.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="3">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Drive Results with Smarter Workflows"
                subtitle="Automation is a game-changer for businesses aiming to scale and remain competitive. By implementing automated systems, businesses can reduce the time spent on repetitive tasks, such as inventory management, payroll processing, or customer service inquiries. Automation not only improves accuracy but also frees up employees to focus on strategic initiatives that drive growth. For example, automated email marketing or chatbots enhance customer engagement while reducing operational overhead. Integrating automation into key processes accelerates operations, ensures consistency, and creates more space for innovation and creative problem-solving in the business environment."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    src={require("../img/tab2.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="4">
              {" "}
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Expand Your Reach and Capabilities"
                subtitle="Scalability is the ability of a business to grow without being hampered by its structure or available resources. Advanced technologies like cloud computing, data analytics, and AI offer businesses the flexibility to scale efficiently as demand increases. These technologies enable your business to handle larger volumes of data, customers, and transactions without compromising performance or quality. Whether you’re expanding geographically, adding new products, or increasing your workforce, scalable solutions allow you to grow seamlessly. By leveraging scalable tools, businesses can avoid bottlenecks, minimize disruptions, and ensure that growth is sustainable in the long term."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    src={require("../img/tab3.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="5">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Make Informed Decisions with Real-Time Insights"
                subtitle="In today’s competitive business environment, relying on gut instinct or outdated data is no longer sufficient. A data-driven approach empowers businesses to make informed, evidence-based decisions that drive growth. By harnessing the power of big data, analytics, and AI, businesses can gain deep insights into customer behavior, market trends, and operational performance. Real-time data allows businesses to respond quickly to changing conditions, identify opportunities, and mitigate risks. Making decisions based on solid data not only improves accuracy but also boosts customer satisfaction, fosters innovation, and ensures that strategies are aligned with market demands."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    alt={"Cutting Edge Digital Marketing"}
                    src={require("../img/tab4.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="6">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Enhance Collaboration Across Teams and Platforms"
                subtitle="In today’s interconnected world, seamless communication and collaboration are critical to business success. Advanced technologies such as cloud-based platforms, collaboration tools, and unified communication systems allow teams to work together more efficiently, regardless of location. Employees can share files, access real-time data, and communicate instantly, fostering a more collaborative environment. With improved connectivity, teams can respond more quickly to challenges, innovate faster, and align efforts towards shared goals. Enhancing connectivity across platforms and teams breaks down silos, boosts morale, and improves overall productivity, ultimately leading to stronger business performance and faster decision-making."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    src={require("../img/tab1.png")}
                  ></img>
                }
              />
            </TabPanel>
          </TabContext>
        </div>
        {state.auth.isMobile ? <div style={{ marginBottom: "-200px" }} /> : ""}

        <div
          style={{
            marginBottom: "-50px",
          }}
        />

        {!state.auth.isMobile ? (
          <SpacerV height={"50px"} />
        ) : (
          <div style={{ marginTop: "-50px" }} />
        )}

        <div
          style={{
            fontSize: state.auth.isMobile ? "25px" : "50px",
            color: "white",
            zIndex: 99,
            fontWeight: "bold",
          }}
        >
          <h2>What Our Happy Clients Are Saying</h2>
        </div>
        {state.auth.isMobile || state.auth.view == "TABP" ? null : (
          <HomeTestimonials state={state} />
        )}
        <Stats />
        <SpacerV height={state.auth.isMobile ? "50px" : "150px"} />

        <div
          style={{
            marginTop: state.auth.view == "TABP" ? "-600px" : "-20px",
            height: "100vh",
            display: state.auth.isMobile ? "none" : "block",
          }}
        >
          <div
            style={{
              height: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
                marginLeft: state.auth.isMobile ? "0px" : "0px",
              }}
            >
              <div
                style={{
                  fontSize: layout.heading[state.auth.view],
                  color: "yellow",
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "center" : "left",
                  marginTop: "150px",
                }}
              >
                <h2>Blog</h2>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "15px 0px 15px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: layout.subheading[state.auth.view],
                  color: "white",
                  zIndex: 999,
                }}
              >
                News and insights on all things by Riches Media Digital.
              </div>
            </div>
            <div
              style={{
                display:
                  state.auth.isMobile || state.auth.view == "TABP"
                    ? "none"
                    : "block",
                marginLeft: "500px",
                width: "40%",
                height: "50%",
                marginTop: "50px",
              }}
            >
              {carouselFragment2}
            </div>
          </div>
        </div>
        {state.auth.isMobile || state.auth.view == "TABP" ? (
          <div
            style={{
              backgroundColor: "#111",
            }}
          >
            <div
              style={{
                fontSize: "8vh",
                color: "white",
                zIndex: 99,
                textAlign: "left",
                fontWeight: "bold",
                marginBottom: "100px",
                padding: state.auth.isMobile ? "15px" : "100px",
              }}
            >
              <div
                style={{
                  marginLeft: state.auth.isMobile ? 0 : "2.2vh",
                  fontSize: layout.subheading[state.auth.view],
                }}
              >
                Latest Blog Posts
              </div>
              <Grid container>
                {blogs["Latest"].map((blog, index) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() =>
                      navigate("/blog/" + blog.slug, {
                        state: {
                          slug: blog.slug,
                        },
                      })
                    }
                    style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      padding: "10px 10px 0px 10px",
                      width: "100%",
                      height: "40vh",
                      zIndex: 100,
                      textAlign: "left",
                      marginBottom: "100px",
                      marginLeft: state.auth.isMobile ? "-15px" : "0px",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "15px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage:
                          "url('" + getBlogImageUrl(blog) + "')",
                        borderRadius: 10,
                      }}
                    ></div>
                    <div
                      style={{
                        fontSize: layout.textMedium[state.auth.view],
                        marginLeft: "15px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    ></div>
                    <div
                      style={{
                        fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                        marginLeft: "15px",
                        color: "white",
                      }}
                    >
                      {blog.title}
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        ) : (
          ""
        )}
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
